import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {getMainViewItemForView} from 'analysis-tool/data-view/AnalysisViewUtils';
import BenchlingConfig from 'BenchlingConfig';

import {AnalysisMainViewItem, AnalysisMainViewItemType} from './main-view/MainViewTypes';
import {getLegacyAnalysisSidebarItemDatas} from './sidebar/SidebarItemDatas';

/**
 * Return default item for a given analysis
 *
 * @deprecated Behavior only applies for when `ENABLE_ANALYSIS_TOOL_LAYOUTS_AND_VIEWS_REDESIGN` is false
 * @see getDefaultMainViewItemForAnalysis for new behavior.
 * @package
 */
export function getLegacyDefaultMainViewItemForAnalysis(analysis: AnalysisGraphQL): AnalysisMainViewItem {
  const sidebarItemDatas = getLegacyAnalysisSidebarItemDatas(analysis);
  return sidebarItemDatas.length > 0
    ? sidebarItemDatas[0].mainViewItem
    : {
        type: AnalysisMainViewItemType.EMPTY_ANALYSIS,
      };
}

/**
 * Return default MainViewItem for a given analysis
 *
 * The default is a `AnalysisMainViewItemType.DATA_VIEW` on the first view in the analysis, and if the analysis is empty
 * the default is a `AnalysisMainViewItemType.EMPTY_ANALYSIS`.
 */
export default function getDefaultMainViewItemForAnalysis(analysis: AnalysisGraphQL): AnalysisMainViewItem {
  if (!BenchlingConfig.ENABLE_ANALYSIS_TOOL_LAYOUTS_AND_VIEWS_REDESIGN) {
    return getLegacyDefaultMainViewItemForAnalysis(analysis);
  }

  if (analysis.views.length > 0) {
    return getMainViewItemForView(analysis.views[0]);
  }

  return {
    type: AnalysisMainViewItemType.EMPTY_ANALYSIS,
  };
}
